import { Button } from 'antd';
import './subs-management.sass';
import { useEffect, useState } from 'react';
import {
  getProfile,
  GetProfileResponse,
  getCustomerSecret,
  getClientPortalUrl,
} from '@/api/custom';
import {
  getStripeCustomerId,
  hasActiveBilling,
  hasStripeBillingPortal,
  isEnterpriseBilling,
} from '@/pages/stripe/billing-status';
import config from '@/services/config';
import { AdvisorRouteSkeleton } from '@/routes/components/route-loading-skeleton';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const SubsManagement = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [portalUrl, setPortalUrl] = useState<string>('');
  const [userSecret, setUserSecret] = useState<string>('');
  const [haveActiveSubscription, setHaveActiveSubscription] = useState<boolean>(false);
  const [haveEnterpriseBilling, setHaveEnterpriseBilling] = useState<boolean>(false);

  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const profileData: GetProfileResponse = await getProfile();
      const stripeInfo = profileData.stripe_info;
      const customerId = getStripeCustomerId(stripeInfo);
      setHaveActiveSubscription(hasActiveBilling(stripeInfo));
      setHaveEnterpriseBilling(isEnterpriseBilling(stripeInfo));
      if (customerId !== null && hasStripeBillingPortal(stripeInfo)) {
        const portalUrl: string = await getClientPortalUrl(customerId);
        setPortalUrl(portalUrl);
      } else if (customerId !== null && !isEnterpriseBilling(stripeInfo)) {
        const userSecret: string = await getCustomerSecret(customerId);
        setUserSecret(userSecret);
      }
    } catch {
      setError('Failed to load profile data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      console.error('ERROR: ', error);
    }
  }, [error]);

  useEffect(() => {
    fetchProfileData();
  }, []);

  if (loading) {
    return <AdvisorRouteSkeleton pathname="/home/subscription" />;
  }

  const stripePricingTable = () => (
    <div className="stripe-container">
      <stripe-pricing-table
        pricing-table-id={config.stripePricingTableId}
        publishable-key={config.stripePublishableKey}
        customer-session-client-secret={userSecret}
      ></stripe-pricing-table>
    </div>
  );

  const clientPortal = () => (
    <Button
      onClick={() => {
        window.open(portalUrl, '_blank');
      }}
    >
      Manage Subs
    </Button>
  );

  return (
    <div className="subs-management" style={{ margin: '4rem' }}>
      {haveEnterpriseBilling ? (
        <p>Billing is managed through your enterprise agreement.</p>
      ) : !loading && haveActiveSubscription ? (
        clientPortal()
      ) : (
        stripePricingTable()
      )}
    </div>
  );
};

export default SubsManagement;
